import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import React, { useEffect } from "react";

// import {ReactComponent as DialogAlert} from "../../assets/images/dialog-alert.svg";
import { ReactComponent as DialogFail } from "../../assets/images/dialog-fail.svg";
import { ReactComponent as DialogCheck } from "../../assets/images/dialog-check.svg";
import { ReactComponent as WarningAlert } from "../../assets/images/wraning.svg";
import CloseIcon from "../../assets/images/plus-circle-fill.svg";

const MessageDialog = (props) => {
  const { t } = useTranslation();
  const handleClose = () => {
    props.setValue(false)
  };
  return (
    <React.Fragment>
      <Dialog
        open={props.open}
        onClose={() => props.page === true ? props.doDirect() : handleClose()}
        maxWidth="xs"
        fullWidth={true}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Box sx={{ position: "absolute", right: 0, margin: "20px 20px 0  0", top: 0 }} className="clickable" onClick={handleClose}><img src={CloseIcon} alt="browser" /></Box>
          <DialogContentText id="alert-dialog-description" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexFlow: 'column' }}>
            {
              props.type === "fail" ?
                <DialogFail></DialogFail>
                : props.type === "warning" ?
                  <WarningAlert></WarningAlert>
                  :
                  <DialogCheck></DialogCheck>
            }
            {props.twoline === true ?
              <Typography mt={3} fontSize={16} sx={{ textAlign: "center" }} dangerouslySetInnerHTML={{ __html: props.text }} color="#404349" ></Typography>
              :
              <>
                <Typography color={props.type === "fail" ? "#CC6058" : props.type === "warning" ? "#F7B254" : "primary"} variant="h3" mt={3}>{props.title}</Typography>
                <pre><Typography textAlign="center" mt={2}>{props.text}</Typography></pre>
              </>
            }
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 20 }}>
          <Button onClick={() => props.page === true ? props.doDirect() : handleClose()} size="large" variant="contained" sx={{ width: '300px', textTransform: "none" }} color={props.type === "fail" ? "red" : props.type === "warning" ? "warning" : "primary"}>{t(`label.close`)}</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
export default MessageDialog;
